<app-navbar-style-two></app-navbar-style-two>

<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Gizlilik Politikası</h3>
            <ul>
                <li><a href="index.html">Ana Sayfa</a></li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Gizlilik Politikası</li>
            </ul>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<div class="terms-conditions-area pt-50 pb-70">
    <div class="container">
        <div class="single-content">
            <h3>Gizlilik Politikamıza Hoş Geldiniz</h3>
            <p>YEOHA Game Studio olarak, kullanıcılarımızın gizliliğine büyük önem veriyoruz. Web sitemizi ve hizmetlerimizi kullanırken paylaştığınız kişisel veriler, KVKK ve ilgili diğer yasal düzenlemeler doğrultusunda korunur.</p>
            <p>Topladığımız bilgiler; yalnızca sizlere daha iyi hizmet sunmak, uygulamalarımızı geliştirmek ve iletişim kurmak amacıyla kullanılır. Bilgileriniz asla üçüncü kişilerle paylaşılmaz, satılmaz veya kötüye kullanılmaz.</p>
        </div>
        <div class="single-content">
            <h3>Hangi Verileri Topluyoruz?</h3>
            <p>İsim, e-posta adresi, telefon numarası gibi iletişim bilgileri, kullanım alışkanlıkları, IP adresi ve cihaz bilgileri gibi teknik veriler toplanabilir. Bu veriler, yalnızca hizmet kalitesini artırmak amacıyla saklanır ve işlenir.</p>
            <p>Uygulamalarımızda veya oyunlarımızda kullanıcı etkileşimini analiz etmek amacıyla çerezler (cookies) kullanılabilir.</p>
        </div>
        <div class="single-content">
            <h3>Verileriniz Nasıl Korunur?</h3>
            <p>YEOHA Game Studio, verilerinizi korumak için güvenlik duvarları, şifreleme ve erişim kontrol sistemleri gibi güncel teknik önlemleri uygular. Verilerinize yalnızca yetkili personel erişebilir.</p>
            <p>Kullanıcılarımızın verilerini yetkisiz erişim, ifşa, değişiklik ve silinmeye karşı en yüksek düzeyde korumak için çalışıyoruz.</p>
        </div>
        <div class="single-content">
            <h3>Üçüncü Taraflarla Paylaşım</h3>
            <p>Kişisel verileriniz, yasal yükümlülükler haricinde üçüncü taraflarla paylaşılmaz. Eğer bir iş ortağıyla paylaşım gerekiyorsa, bu yalnızca açık rızanız alınarak ve gizlilik sözleşmesi çerçevesinde yapılır.</p>
        </div>
        <div class="single-content">
            <h3>Haklarınız Nelerdir?</h3>
            <p>6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında, dilediğiniz zaman verilerinize erişme, düzeltme, silme, işlenmesini durdurma ve itiraz etme haklarına sahipsiniz.</p>
            <p>Bu haklarınızı kullanmak için bizimle <strong>info@yeohagamestudio.com</strong> adresinden iletişime geçebilirsiniz.</p>
        </div>
        <div class="single-content">
            <h3>Değişiklikler</h3>
            <p>YEOHA Game Studio, Gizlilik Politikası üzerinde zaman zaman değişiklik yapabilir. Güncellemeler bu sayfada yayınlanır ve kullanıcılarımız bilgilendirilir. Gizlilik politikasını düzenli olarak kontrol etmenizi öneririz.</p>
        </div>
    </div>
</div>


<!-- <div class="brand-logo-area pt-100">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo1.png" alt="Images">
                </div>
                
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo2.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo3.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo4.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo5.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo6.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div> -->

<app-footer-style-two></app-footer-style-two>